<template>
  <v-select
    v-model="selectedWay"
    :items="listOfWays"
    item-text="title"
    item-value="id"
    label="Спосіб списання"
    return-object
    hide-details
    dense
    :menu-props="{
      nudgeRight: 30,
      transition: 'scale-transition',
      offsetY: ''
    }"
    outlined
    @input="selectWay"
  />
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      selectedWay: null,
      listOfWays: [
        { title: "З пакету", id: 0 },
        { title: "Рахунок", id: 1 },
      ],
    };
  },
  watch: {
    value: {
      handler() {
        const writeOffway = this.listOfWays.find(el => el.id === this.value);
        if (writeOffway) {
          this.selectedWay = writeOffway;
        } else {
          this.selectedWay = this.listOfWays[0];
        }
      },
      immediate: true,
    },
  },
  methods: {
    selectWay() {
      this.$emit("input", this.selectedWay.id);
    },
  },
};
</script>
